export default {
    API_URL: 'http://localhost:5192/api/v1/',
    TRAVEL_URL: 'http://localhost:5244/api/v1/',
    CURRENT_HOTEL: '2080294c-0d46-43d5-9210-2a8f30344878'
}